export const SET_CALIFORNIA_TOAST_FLAG = 'SET_CALIFORNIA_TOAST_FLAG'
export const SET_CALIFORNIA_TOAST_CLOSED = 'SET_CALIFORNIA_TOAST_CLOSED' 
export const SET_CALIFORNIA_TOAST_TEXT = 'SET_CALIFORNIA_TOAST_TEXT'
export const SET_IS_CALIFORNIA_CUSTOMER = 'SET_IS_CALIFORNIA_CUSTOMER'
export const SET_IS_COC_AGENT = 'SET_IS_COC_AGENT';
